<template>
    <c-dialog ref="dialog" enable-flex width="85vw" mode="slide" mask-close>
        <template #head>
            <div class="m-detail-tag flex-center-cross">
                <c-state tag async dict="CHECK_PAYMENT_CHANNEL" :value="check_payment_channel"></c-state>
            </div>
        </template>

        <div v-if="diffCount > 0" class="m-check-diff-tip">
            有 {{diffCount}} 条明细的【最终结算金额】与【平台金额（平台订单金额-平台售后金额-平台补差金额）】不一致，已标红，请核对
        </div>
        <c-form ref="purchaseForm" column="3" vertical unit-width="100%">
            <c-title>核销商品明细</c-title>
            <c-table ref="productTable" :data="productList" border :paging="false">
                <c-table-column label="小黑订单号" width="220" required :summed="true">
                    <template #default="{data}">
                        <span>{{data.order_no||'-'}}</span>
                    </template>
                    <template #summed>
                        <span>合计</span>
                    </template>
                </c-table-column>
                <c-table-column label="三方流水号" width="180" required>
                    <template #default="{data}">
                        <span>{{data.third_number||'-'}}</span>
                    </template>
                </c-table-column>
                <c-table-column label="背贴码" width="150" required>
                    <template #default="{data}">
                        <span>{{data.produce_unique_code||'-'}}</span>
                        <c-input type="hidden" name="inspection_state" v-model="data.inspection_state"></c-input>
                    </template>
                </c-table-column>
<!--                <c-table-column label="核销状态" width="100" required>
                    <template #default="{data}">
                        <c-state tag async dict="CHECK_ORDER_STATUS" :value="data.check_state"></c-state>
                    </template>
                </c-table-column>
                <c-table-column label="已结算金额" width="120" required>
                    <template #default="{data}">
                        <span>￥{{data.check_settled_money||'0.00'}}</span>
                    </template>
                </c-table-column>-->
                <c-table-column label="渠道订单金额" width="120" required :summed="sumField('check_product_money')">
                    <template #default="{data}">
                        <span>￥{{ money(data.check_product_money) }}</span>
                    </template>
                    <template #summed="{total}">
                        <span>￥{{ money(total) }}</span>
                    </template>
                </c-table-column>
                <c-table-column label="渠道售后金额" width="120" required :summed="sumField('check_return_money')">
                    <template #default="{data}">
                        <span v-if="toCent(data.check_return_money) != 0" style="color:red">￥{{ money(data.check_return_money) }}</span>
                        <span v-else>￥0.00</span>
                    </template>
                    <template #summed="{total}">
                        <span>￥{{ money(total) }}</span>
                    </template>
                </c-table-column>
                <c-table-column label="渠道补差金额" width="120" required :summed="sumField('check_supplement_money')">
                    <template #default="{data}">
                        <span v-if="toCent(data.check_supplement_money) != 0" style="color:red">￥{{ money(data.check_supplement_money) }}</span>
                        <span v-else >￥0.00</span>
                    </template>
                    <template #summed="{total}">
                        <span>￥{{ money(total) }}</span>
                    </template>
                </c-table-column>
                <c-table-column label="渠道实收金额" width="120" required :summed="sumField('check_receipt_money')">
                    <template #default="{data}">
                        <span v-if="toCent(data.check_receipt_money) > 0" style="color:green">￥{{ money(data.check_receipt_money) }}</span>
                        <span v-else-if="toCent(data.check_receipt_money) < 0" style="color:red">￥{{ money(data.check_receipt_money) }}</span>
                        <span v-else >￥0.00</span>
                    </template>
                    <template #summed="{total}">
                        <span>￥{{ money(total) }}</span>
                    </template>
                </c-table-column>
                <c-table-column label="最终结算金额" width="150" required :summed="sumField('platform_receipt_money')">
                    <template #default="{data}">
                        <span :class="{'m-check-diff': isDiff(data)}" :title="diffTitle(data)">￥{{ money(data.platform_receipt_money) }}<i v-if="isDiff(data)" class="m-check-diff-flag">!</i></span>
                    </template>
                    <template #summed="{total}">
                        <span>￥{{ money(total) }}</span>
                    </template>
                </c-table-column>
                <c-table-column label="平台订单金额" width="120" required :summed="sumField('platform_sale_price')">
                    <template #default="{data}">
                        <span>￥{{ money(data.platform_sale_price) }}</span>
                    </template>
                    <template #summed="{total}">
                        <span>￥{{ money(total) }}</span>
                    </template>
                </c-table-column>
                <c-table-column label="平台售后金额" width="120" required :summed="sumField('platform_return_money')">
                    <template #default="{data}">
                        <span>￥{{ money(data.platform_return_money) }}</span>
                    </template>
                    <template #summed="{total}">
                        <span>￥{{ money(total) }}</span>
                    </template>
                </c-table-column>
                <c-table-column label="平台补差金额" width="120" required :summed="sumField('platform_supplement_money')">
                    <template #default="{data}">
                        <span>￥{{ money(data.platform_supplement_money) }}</span>
                    </template>
                    <template #summed="{total}">
                        <span>￥{{ money(total) }}</span>
                    </template>
                </c-table-column>
                <c-table-column label="收款日期" width="180" required>
                    <template #default="{data}">
                        <span>{{data.receipt_date||''}}</span>
                    </template>
                </c-table-column>

                <c-table-column type="button" label="操作" width="120">
                    <template #default="row">
                        <c-table-button icon="tf-trash" color="red" @click="removeRow(row);">删除</c-table-button>
                    </template>
                </c-table-column>
            </c-table>
        </c-form>
        <template #button>
            <c-button v-if="auth('b_xiaohei_order_check_create')" size="dialog" :disabled="isSubmitting" @click="submitHandle(0)">{{isEdit ? '暂存草稿' : '保存草稿'}}</c-button>
            <c-button v-if="auth('b_xiaohei_order_check_audit')" color="main" size="dialog" :disabled="isSubmitting" @click="submitHandle(2)">{{isEdit ? '提交审核' : '保存并提交审核'}}</c-button>
        </template>
    </c-dialog>
</template>

<script>

export default {
    name: 'orderCheckEdit',
    components: {
    },

    data() {
        return {
            check_payment_channel:0,//付款渠道
            check_order_id:0,//编辑的核销单ID（0=新增导入）
            isEdit:false,//是否编辑模式（待核销/审核驳回状态可编辑）
            productList:[],
            isSubmitting:false//是否正在提交（防止重复提交）
        }
    },

    computed: {
        //最终结算金额与平台金额不一致的明细条数（用于表格上方提示）
        diffCount() {
            return (this.productList || []).filter(item => this.isDiff(item)).length;
        }
    },

    methods: {
        //打开弹窗
        open(data) {
            this.check_payment_channel = data.check_payment_channel;
            this.check_order_id = data.id||0;
            this.isEdit = !!this.check_order_id;//携带核销单ID则为编辑模式
            this.productList = (data.import_data_list||[]).map(item => this.prepareRow(item));
            this.isSubmitting = false;//重置提交状态（兜底，防止上次异常中断导致标志卡死）
            this.$refs.dialog.open({
                title: this.isEdit ? '编辑核销单' : '批量导入核销'
            });
            if (this.isEdit) {
                this.loadProductList();
            }
        },
        /******编辑模式：加载核销单商品明细并回显*********/
        loadProductList() {
            this.request({
                url: '/sale/check/product/list',
                data: {
                    check_order_id: this.check_order_id,
                    pageIndex: 1,
                    pageSize: 999
                },
                loading: true,
                success: data => {
                    this.productList = (data||[]).map(item => this.prepareRow(item));
                }
            });
        },
        /******删除行数据*********/
        removeRow(row) {
            this.$confirm({
                type: 'warn',
                message: (row.data.produce_unique_code ? '是否确认删除背贴码【' + row.data.produce_unique_code + '】' : '是否确认删除选中数据行'),
                buttonName: '确认删除',
                cancelButton: true,
                resolve: () => {
                    row.remove();
                }
            });
        },
        /*******提交编辑数据********************/
        submitHandle(status) {
            //防止重复提交：请求进行中直接忽略点击
            if (this.isSubmitting) return;
            //产品工单列表
            var product_list = this.$refs.productTable.getData();

            if (!product_list || product_list.length == 0){
                this.$message({
                    message: '至少需要核销一件商品',
                    type: 'warn'
                });
                return;
            }
            //【最终结算金额】由【渠道订单金额-渠道售后金额-渠道补差金额】自动计算（页面不可手改），
            //此处兜底校验，避免行数据被外部修改后提交错误金额
            const diffList = product_list.filter(item => this.toCent(item.platform_receipt_money) !== this.finalAmountCent(item));
            if (diffList && diffList.length > 0){
                this.$message({
                    message: '商品的“最终结算金额”，必须等于“渠道订单金额-渠道售后金额-渠道补差金额”',
                    type: 'warn'
                });
                return;
            }
            this.isSubmitting = true;
            this.request({
                //编辑模式：更新核销单（暂存待核销/提交审核）；新增模式：新增核销单
                url: this.isEdit ? '/sale/check/update' : '/sale/check/add',
                //请求期间显示全屏遮罩，物理阻断重复点击
                loading: true,
                data: this.isEdit ? {
                    id:this.check_order_id,
                    status:status,
                    product_list:product_list
                } : {
                    status:status,
                    check_payment_channel:this.check_payment_channel,
                    product_list:product_list
                },
                success:data => {
                    this.$message({
                        message: status==0?'数据已保存为“待核销”状态':'数据已保存为“待审核”状态，等待审核',
                        type: 'success'
                    });
                    //执行回调函数
                    this.$emit('resolve');
                    this.$refs.dialog.close();
                },
                //成功/业务失败后均会执行，重置提交状态
                complete:() => {
                    this.isSubmitting = false;
                },
                //网络异常/超时时complete不会执行，此处兜底重置
                error:() => {
                    this.isSubmitting = false;
                }
            })
        },
        /**金额转分：页面内金额比较统一用分，避免浮点误差*/
        toCent(value) {
            return Math.round(Number(value || 0) * 100);
        },
        /**金额展示：统一保留两位小数*/
        money(value) {
            return Number(value || 0).toFixed(2);
        },
        /**合计行取值：按字段累加当前明细（c-table 的 summed 回调）*/
        sumField(field) {
            return ({data}) => Number(data[field]) || 0;
        },
        /**最终结算金额（分）= 渠道订单金额 - 渠道售后金额 - 渠道补差金额*/
        finalAmountCent(item) {
            return this.toCent(item.check_product_money) - this.toCent(item.check_return_money) - this.toCent(item.check_supplement_money);
        },
        /**平台金额（分）= 平台订单金额 - 平台售后金额 - 平台补差金额*/
        platformAmountCent(item) {
            return this.toCent(item.platform_sale_price) - this.toCent(item.platform_return_money) - this.toCent(item.platform_supplement_money);
        },
        /**最终结算金额与平台金额是否不一致*/
        isDiff(item) {
            return this.finalAmountCent(item) !== this.platformAmountCent(item);
        },
        /**不一致时的悬浮提示（含差额）*/
        diffTitle(item) {
            if (!this.isDiff(item)) return '';
            const diff = (this.finalAmountCent(item) - this.platformAmountCent(item)) / 100;
            return '与平台金额不一致，差额 ￥' + this.money(diff);
        },
        /**明细行预处理：最终结算金额直接取【渠道订单金额-渠道售后金额-渠道补差金额】*/
        prepareRow(item) {
            //用 $set 赋值：避免后端未返回该字段时新增属性非响应式，导致展示与合计不刷新
            this.$set(item, 'platform_receipt_money', this.finalAmountCent(item) / 100);
            return item;
        }
    }
}
</script>

<style lang="stylus" scoped>
.m-check-diff-tip
    margin-bottom 10px
    padding 8px 12px
    border 1px solid #ffccc7
    border-radius 4px
    background #fff2f0
    color #f5222d
    font-size 13px
    line-height 20px

.m-check-diff
    color #f5222d
    font-weight 600

.m-check-diff-flag
    display inline-block
    width 14px
    height 14px
    margin-left 4px
    border-radius 50%
    background #f5222d
    color #fff
    font-size 11px
    font-style normal
    line-height 14px
    text-align center
    vertical-align middle
</style>